import { ChevronDown, Clock } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const DEFAULT_HERO_IMG =
  "https://customer-assets.emergentagent.com/job_85512f74-aa35-4a50-bb9f-c899943066c1/artifacts/now99qsr_468303231_122171145896137402_7412612925861017942_n.jpg";

export default function Hero({ content }) {
  const { lang, t, pick } = useLang();
  const scrollDown = () => {
    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
  };

  const heroImg = content?.hero_image_url || DEFAULT_HERO_IMG;
  const overlay = Math.max(0, Math.min(100, content?.hero_overlay ?? 55)) / 100;
  const top = Math.min(1, overlay + 0.1);
  const mid = Math.max(0, overlay - 0.15);
  const bottom = Math.min(1, overlay + 0.15);

  return (
    <section
      id="home"
      className="relative min-h-[100svh] flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(to bottom, rgba(0,0,0,${top.toFixed(
            2
          )}), rgba(0,0,0,${mid.toFixed(2)}), rgba(0,0,0,${bottom.toFixed(2)}))`,
        }}
      />

      <div className="relative afb-container text-center text-white afb-fade-up py-24 sm:py-32">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/5 backdrop-blur mb-6 sm:mb-8">
          <Clock className="w-3.5 h-3.5 text-afb-gold" />
          <span className="text-[11px] sm:text-xs uppercase tracking-[0.28em] text-white/80">
            {t("common.available_24_7")}
          </span>
        </div>

        <h1 className="serif text-[2.4rem] leading-[1.08] sm:text-5xl lg:text-7xl tracking-tight max-w-4xl mx-auto">
          {pick(content, "hero_title")}
        </h1>

        <div className="mt-5 sm:mt-6 flex items-center justify-center text-white/70">
          <span className="afb-divider !bg-[color:var(--afb-gold)] !w-8 sm:!w-12" />
          <span className="text-[10px] sm:text-sm uppercase tracking-[0.28em] sm:tracking-[0.32em]">
            {pick(content, "hero_subtitle")}
          </span>
          <span className="afb-divider !bg-[color:var(--afb-gold)] !w-8 sm:!w-12" />
        </div>

        <p className="mt-6 sm:mt-8 max-w-2xl mx-auto text-[15px] sm:text-lg text-white/80 leading-relaxed">
          {pick(content, "hero_tagline")}
        </p>

        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 max-w-sm sm:max-w-none mx-auto">
          <button onClick={scrollDown} className="afb-btn-gold" data-testid="hero-cta-services">
            {lang === "it" ? "I nostri servizi" : "Our services"}
          </button>
          <a
            href={`tel:${(content?.phone_giuseppe || "").replace(/\s/g, "")}`}
            className="afb-btn-ghost border-white/40 !text-white hover:!text-afb-ink hover:!bg-white"
            data-testid="hero-cta-call"
          >
            {t("common.call_now")}
          </a>
        </div>
      </div>

      <button
        onClick={scrollDown}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-white animate-bounce"
        aria-label="scroll"
        data-testid="hero-scroll-indicator"
      >
        <ChevronDown className="w-6 h-6" />
      </button>
    </section>
  );
}
